var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: !_vm.visible,
      expression: "!visible"
    }],
    ref: "observeTarget",
    staticClass: "lazy-component"
  }, [_vm.visible ? _c('div', [_vm._t("default")], 2) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }